import PercentInput from 'components/PercentInput';
import React from 'react';
import { Edit, FormDataConsumer, NumberInput, SimpleForm } from 'react-admin';
import useIsAdmin from 'hooks/useIsAdmin';

const JobProfileEdit = () => {
  const isAdmin = useIsAdmin();

  return (
    <Edit mutationMode="pessimistic" redirect="show">
      <SimpleForm>
        <NumberInput disabled label="Job ID" source="job_id" />
        <NumberInput disabled label="Agency ID" source="agency_id" />
        {isAdmin() && (
          <FormDataConsumer>
            {({ formData }) => {
              return (
                !!formData.agency_id && (
                  <PercentInput label="Agency VMS Fee percent" source="agency_vms_fee_percent" />
                )
              );
            }}
          </FormDataConsumer>
        )}
      </SimpleForm>
    </Edit>
  );
};

export default JobProfileEdit;
